// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAddToListLinkStyles } from "@eisinc/Overrides/Components/ProductAddToListLink";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { css } from "styled-components";

productAddToListLinkStyles.link = {
    css: css`
        > span {
            display: flex;
            align-items: center;
            > span:first-child {
                margin-right: 6px;
            }
        }
    `,
};

productAddToListLinkStyles.addToListText = {
    size: fontConfig.xSmall.size,
    lineHeight: fontConfig.singleLinexSmall.lineHeight,
    weight: fontConfig.weight.medium,
};
